import dialogSkin from "../common/dialog.skin";

const columnsModalSkin = {
  ...dialogSkin,
  "horizontal-line": {
    "border-top": "1px solid var(--gc-border-separator-color)",
    "margin-top": "3px",
    "margin-bottom": "3px",
  },
  tabs: {
    composes: "nav nav-pills",
    ".nav-pills&": {
      "margin-bottom": "10px",
      "list-style": "none",
      "padding-inline-start": "unset",
    },
  },
  "tab-button": {
    composes: "nav-link",
    ".nav-link&": {
      cursor: "pointer",
    },
  },
};

export default columnsModalSkin;
